// **React Imports
import { memo } from 'react'

// **MUI Imports
import { styled } from '@mui/material'

// **Image Imports
import angularIcon from '../../assets/images/editor-files-logo/angular.svg'
import cSharpIcon from '../../assets/images/editor-files-logo/csharp.svg'
import cssIcon from '../../assets/images/editor-files-logo/css.svg'
import fileIcon from '../../assets/images/editor-files-logo/file.svg'
import folderIcon from '../../assets/images/editor-files-logo/folder.svg'
import htmlIcon from '../../assets/images/editor-files-logo/html.svg'
import javaIcon from '../../assets/images/editor-files-logo/java.svg'
import reactIcon from '../../assets/images/editor-files-logo/react.svg'
import javascriptExtensionIcon from '../../assets/images/editor-files-logo/javascript-extension.svg'
import javascriptIcon from '../../assets/images/editor-files-logo/javascript.svg'
import pythonIcon from '../../assets/images/editor-files-logo/python.svg'
import typescriptExtensionIcon from '../../assets/images/editor-files-logo/typescript-extension.svg'
import typescriptIcon from '../../assets/images/editor-files-logo/typescript.svg'
import jupyterIcon from '../../assets/images/editor-files-logo/jupyter.svg'
import postgresIcon from '../../assets/images/editor-files-logo/postgres.svg'
import dbtIcon from '../../assets/images/editor-files-logo/dbt.svg'
import ymlIcon from '../../assets/images/editor-files-logo/yml.svg'
import sqlIcon from '../../assets/images/editor-files-logo/sql.svg'
import jsonIcon from '../../assets/images/editor-files-logo/json.svg'
import logIcon from '../../assets/images/editor-files-logo/log.svg'
import WebBasicIcon from '../../assets/images/editor-files-logo/html.svg'
import FlaskIcon from '../../assets/images/editor-files-logo/flask.svg'
import ExpressIcon from '../../assets/images/editor-files-logo/express.svg'
import NestJSIcon from '../../assets/images/editor-files-logo/nestjs.svg'
import FastAPIIcon from '../../assets/images/editor-files-logo/fastapi.svg'
import NextJSIcon from '../../assets/images/editor-files-logo/nextjs.svg'

const StyledImage = styled('img')(({ maxWidth, width }) => ({
  width: width || 'auto',
  maxWidth: maxWidth || '18px',
  height: 'auto',
  objectFit: 'contain'
}))

// ** FileIcon Component **
const FileIcon = ({
  iconName,
  language,
  width = null,
  maxWidth = null,
  title = ''
}) => {
  return (
    <StyledImage
      width={width}
      maxWidth={maxWidth}
      className="editor-file-icon"
      src={
        iconName === 'javascript.svg'
          ? javascriptIcon
          : iconName === 'typescript.svg'
          ? typescriptIcon
          : iconName === 'html.svg'
          ? htmlIcon
          : iconName === 'css.svg'
          ? cssIcon
          : iconName === 'java.svg'
          ? javaIcon
          : iconName === 'python.svg'
          ? pythonIcon
          : iconName === 'javascript-extension.svg'
          ? javascriptExtensionIcon
          : iconName === 'react.svg'
          ? reactIcon
          : iconName === 'csharp.svg'
          ? cSharpIcon
          : iconName === 'jupyter.svg'
          ? jupyterIcon
          : iconName === 'angular.svg'
          ? angularIcon
          : iconName === 'typescript-extension.svg'
          ? typescriptExtensionIcon
          : iconName === 'postgres.svg'
          ? postgresIcon
          : iconName === 'dbt.svg'
          ? dbtIcon
          : iconName === 'yml.svg'
          ? ymlIcon
          : iconName === 'sql.svg'
          ? sqlIcon
          : iconName === 'json.svg'
          ? jsonIcon
          : iconName === 'log.svg'
          ? logIcon
          : iconName === 'folder'
          ? folderIcon
          : iconName === 'html.svg'
          ? WebBasicIcon
          : iconName === 'flask.svg'
          ? FlaskIcon
          : iconName === 'express.svg'
          ? ExpressIcon
          : iconName === 'nestjs.svg'
          ? NestJSIcon
          : iconName === 'fastapi.svg'
          ? FastAPIIcon
          : iconName === 'nextjs.svg'
          ? NextJSIcon
          : fileIcon
      }
      alt={language || 'icon'}
      {...(title ? { title } : {})}
    />
  )
}

export default memo(FileIcon)
